// removed by extract-text-webpack-plugin
module.exports = {"container":"g1_g","back":"g1_g2","arrow":"g1_g0","button":"g1_bp _1kB_d9laDuyaX1azPOvneD","triggerOpen":"g1_g3","trigger":"g1_g4","triggerHidden":"g1_g5","unavailableList":"g1_g6"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventTicketsPage/components/EventTickets/styles.module.css
// module id = 1339
// module chunks = 27